var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    { staticClass: "enterprise-map position-relative" },
    [
      _c("div", { staticClass: "custom-select d-none" }, [
        _c(
          "div",
          { staticClass: "custom-select__filter d-flex align-items-center" },
          [
            _vm.categories
              ? _c("v-select", {
                  attrs: {
                    items: _vm.categories,
                    "item-text": "name",
                    "item-value": "id",
                    "return-object": "",
                    name: "selectedCategory",
                    label: _vm.selectedCategory.name,
                  },
                  on: { change: _vm.changeMapImg },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "selection",
                        fn: function (data) {
                          return [
                            _vm._v(
                              "\n                    " +
                                _vm._s(data.item.name) +
                                "\n                "
                            ),
                          ]
                        },
                      },
                      {
                        key: "item",
                        fn: function (data) {
                          return [
                            _c(
                              "a",
                              {
                                staticClass: "custom-select__link",
                                on: {
                                  click: function ($event) {
                                    $event.preventDefault()
                                    return _vm.sendFilter(data.item)
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  "\n                        " +
                                    _vm._s(data.item.name) +
                                    "\n                    "
                                ),
                              ]
                            ),
                          ]
                        },
                      },
                    ],
                    null,
                    false,
                    3000739351
                  ),
                  model: {
                    value: _vm.selectedCategory,
                    callback: function ($$v) {
                      _vm.selectedCategory = $$v
                    },
                    expression: "selectedCategory",
                  },
                })
              : _vm._e(),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c(
        "v-tabs",
        {
          staticClass: "mb-35",
          attrs: {
            "next-icon": "mdi-arrow-right-bold-box-outline",
            "prev-icon": "mdi-arrow-left-bold-box-outline",
            "show-arrows": "",
          },
          on: { change: _vm.changeTab },
          model: {
            value: _vm.tab,
            callback: function ($$v) {
              _vm.tab = $$v
            },
            expression: "tab",
          },
        },
        [
          _c("v-tabs-slider"),
          _vm._v(" "),
          _vm._l(_vm.items, function (item) {
            return _c("v-tab", [
              _c("span", { staticClass: "enterprise-map__tab" }, [
                _vm._v(
                  "\n                       " +
                    _vm._s(item.label) +
                    "\n                "
                ),
              ]),
            ])
          }),
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "v-tabs-items",
        {
          model: {
            value: _vm.tab,
            callback: function ($$v) {
              _vm.tab = $$v
            },
            expression: "tab",
          },
        },
        _vm._l(_vm.items, function (item) {
          return _c(
            "v-tab-item",
            [
              _c("v-card", { attrs: { flat: "" } }, [
                _c(
                  "div",
                  { staticClass: "enterprise-map__content position-relative" },
                  [
                    _c("div", { staticClass: "сlickСoordinates" }, [
                      _vm._v("✔ Координаты клика скопированы в буфер!"),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "position-relative" }, [
                      _c("img", {
                        staticClass: "enterprise-map__img",
                        attrs: { src: _vm.mapImg, alt: "" },
                      }),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "enterprise-map__dots-container" },
                        _vm._l(item.dots, function (dot, idx) {
                          return _c(
                            "div",
                            {
                              key: idx,
                              staticClass: "enterprise-map__dots",
                              class: {
                                "is-active":
                                  (item.point === idx ||
                                    (item.point === null && idx === 0)) &&
                                  item.panelOpen,
                              },
                              style: {
                                left: dot.dotX + "%",
                                top: dot.dotY + "%",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.handleDotClick(item, idx)
                                },
                              },
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "enterprise-map__dot" },
                                [
                                  item.img_type == "Производство"
                                    ? _c("img", {
                                        attrs: {
                                          src: "/upload/production.svg",
                                          alt: "",
                                        },
                                      })
                                    : _vm._e(),
                                  _vm._v(" "),
                                  item.img_type == "Склад"
                                    ? _c("img", {
                                        attrs: {
                                          src: "/upload/storage.svg",
                                          alt: "",
                                        },
                                      })
                                    : _vm._e(),
                                  _vm._v(" "),
                                  item.img_type == ""
                                    ? _c("img", {
                                        attrs: { src: dot.img_url, alt: "" },
                                      })
                                    : _vm._e(),
                                ]
                              ),
                            ]
                          )
                        }),
                        0
                      ),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "enterprise-map__info",
                        class: { "is-hidden": !item.panelOpen },
                      },
                      [
                        _c(
                          "button",
                          {
                            staticClass: "enterprise-map__close",
                            attrs: { type: "button" },
                            on: {
                              click: function ($event) {
                                return _vm.closeInfoPanel(item)
                              },
                            },
                          },
                          [_vm._v("X")]
                        ),
                        _vm._v(" "),
                        _vm._l(item.dots, function (info, idx) {
                          return _c(
                            "div",
                            {
                              key: idx,
                              staticClass: "enterprise-map__card enterprise",
                              class: {
                                "is-active":
                                  (item.point === idx ||
                                    (item.point === null && idx === 0)) &&
                                  item.panelOpen,
                              },
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    "overflow-y": "scroll",
                                    "overflow-x": "hidden",
                                  },
                                },
                                _vm._l(
                                  info.contentInfo,
                                  function (detail, index) {
                                    return _c(
                                      "div",
                                      {
                                        key: index,
                                        staticClass: "enterprise__card",
                                      },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "enterprise__top" },
                                          [
                                            _c(
                                              "svg",
                                              {
                                                attrs: {
                                                  width: "40",
                                                  height: "40",
                                                  viewBox: "0 0 40 40",
                                                  fill: "none",
                                                  xmlns:
                                                    "http://www.w3.org/2000/svg",
                                                },
                                              },
                                              [
                                                _c("path", {
                                                  attrs: {
                                                    d: "M26.0439 26.041H22.8243C22.1583 26.041 21.6172 26.5813 21.6172 27.2481C21.6172 27.9159 22.1583 28.4553 22.8243 28.4553H26.0439C26.71 28.4553 27.2519 27.9159 27.2519 27.2481C27.2519 26.5806 26.71 26.041 26.0439 26.041Z",
                                                    fill: "#FA4237",
                                                  },
                                                }),
                                                _vm._v(" "),
                                                _c("path", {
                                                  attrs: {
                                                    d: "M32.1903 26.041H28.8713C28.2052 26.041 27.6641 26.5813 27.6641 27.2481C27.6641 27.9159 28.2052 28.4553 28.8713 28.4553H32.1903C32.8563 28.4553 33.3959 27.9159 33.3959 27.2481C33.3959 26.5806 32.8563 26.041 32.1903 26.041Z",
                                                    fill: "#FA4237",
                                                  },
                                                }),
                                                _vm._v(" "),
                                                _c("path", {
                                                  attrs: {
                                                    d: "M8.27014 15.6155H18.8839C19.551 15.6155 20.0911 15.0756 20.0911 14.4087C20.0911 13.741 19.551 13.2012 18.8839 13.2012H8.27014C7.60318 13.2012 7.0625 13.741 7.0625 14.4087C7.06236 15.0755 7.60305 15.6155 8.27014 15.6155Z",
                                                    fill: "#FA4237",
                                                  },
                                                }),
                                                _vm._v(" "),
                                                _c("path", {
                                                  attrs: {
                                                    d: "M38.7911 37.3378H37.2137V16.9752C37.2137 16.3082 36.6718 15.7676 36.0057 15.7676H33.393V3.45178C33.393 2.78483 32.8519 2.24414 32.186 2.24414H28.8669C28.2008 2.24414 27.6597 2.78483 27.6597 3.45178V15.7676H26.5981V3.45178C26.5981 2.78483 26.0561 2.24414 25.39 2.24414H22.0718C21.4058 2.24414 20.8654 2.78483 20.8654 3.45178V15.7676H3.99433C3.32738 15.7676 2.78587 16.3082 2.78587 16.9752V37.3378H1.20764C0.54 37.3378 0 37.8781 0 38.5467C0 39.2137 0.539863 39.7539 1.20764 39.7539H3.99433H8.27393H18.8877H36.0066H38.7928C39.4589 39.7539 40 39.2137 40 38.5467C39.999 37.8773 39.4589 37.3378 38.7911 37.3378ZM9.4802 37.3378V28.4556H17.6784V37.3378H9.4802Z",
                                                    fill: "#FA4237",
                                                  },
                                                }),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticClass: "enterprise__name",
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "enterprise__subtitle",
                                                  },
                                                  [_vm._v(_vm._s(detail.type))]
                                                ),
                                                _vm._v(" "),
                                                _c("p", [
                                                  _vm._v(_vm._s(detail.name)),
                                                ]),
                                              ]
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c("hr"),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "enterprise__block" },
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "enterprise__subtitle",
                                              },
                                              [_vm._v("Адрес")]
                                            ),
                                            _vm._v(" "),
                                            _c("p", [
                                              _vm._v(_vm._s(detail.address)),
                                            ]),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        detail.products ? _c("hr") : _vm._e(),
                                        _vm._v(" "),
                                        detail.products
                                          ? _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "enterprise__block",
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "enterprise__subtitle",
                                                  },
                                                  [_vm._v("Продукты")]
                                                ),
                                                _vm._v(" "),
                                                _c("p", [
                                                  _vm._v(
                                                    _vm._s(detail.products)
                                                  ),
                                                ]),
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        detail.services ? _c("hr") : _vm._e(),
                                        _vm._v(" "),
                                        detail.services
                                          ? _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "enterprise__block",
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "enterprise__subtitle",
                                                  },
                                                  [_vm._v("Услуги")]
                                                ),
                                                _vm._v(" "),
                                                _c("p", [
                                                  _vm._v(
                                                    _vm._s(detail.services)
                                                  ),
                                                ]),
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _c("hr"),
                                        _vm._v(" "),
                                        detail.url
                                          ? _c(
                                              "a",
                                              {
                                                staticClass: "enterprise__btn",
                                                attrs: { href: detail.url },
                                              },
                                              [
                                                _vm._v(
                                                  "\n                                        Подробнее\n                                    "
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                      ]
                                    )
                                  }
                                ),
                                0
                              ),
                            ]
                          )
                        }),
                      ],
                      2
                    ),
                  ]
                ),
              ]),
            ],
            1
          )
        }),
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }